import { categories, categoryIcons } from '@/mocks/categories';
import { Link } from 'react-router-dom';

const featuredCategories = [
  {
    name: 'Sneakers Spreadsheet',
    desc: 'Najlepsze sneakersy w jednym miejscu',
    url: 'https://kaspreadsheet.com/category-911-Shoes.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=Three%20pairs%20of%20trendy%20sneakers%20in%20neutral%20cream%20beige%20and%20sage%20tones%20displayed%20on%20light%20wooden%20platform%20against%20clean%20white%20wall%2C%20soft%20natural%20daylight%20from%20right%2C%20editorial%20product%20photography%2C%20minimalist%20aesthetic%2C%20gentle%20shadows%2C%20contemporary%20fashion%20display&width=600&height=400&seq=cat-sneakers-v2&orientation=landscape',
  },
  {
    name: 'Hoodie Spreadsheet',
    desc: 'Bluzy i swetry — jakość i styl',
    url: 'https://kaspreadsheet.com/search-912/name/Shoes.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=Soft%20cream%20oversized%20hoodie%20casually%20draped%20over%20minimalist%20chair%20with%20warm%20golden%20hour%20sunlight%20streaming%20through%20sheer%20curtain%2C%20cozy%20bedroom%20corner%20aesthetic%2C%20editorial%20lifestyle%20photography%2C%20sand%20beige%20and%20warm%20white%20tones%2C%20serene%20comfortable%20atmosphere&width=600&height=400&seq=cat-hoodie-v2&orientation=landscape',
  },
  {
    name: 'Jacket Spreadsheet',
    desc: 'Kurtki na każdą porę roku',
    url: 'https://kaspreadsheet.com/search-914/name/Shoes.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=Lightweight%20camel%20colored%20trench%20coat%20hanging%20gracefully%20on%20minimalist%20wooden%20wall%20hook%2C%20soft%20morning%20light%20casting%20elegant%20shadows%2C%20clean%20modern%20interior%2C%20editorial%20fashion%20photography%2C%20warm%20sand%20and%20cream%20palette%2C%20sophisticated%20simplicity&width=600&height=400&seq=cat-jacket-v2&orientation=landscape',
  },
  {
    name: 'Bag Spreadsheet',
    desc: 'Torby i plecaki — funkcjonalność',
    url: 'https://kaspreadsheet.com/search-921/name/Shoes.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=Stylish%20leather%20backpack%20and%20canvas%20tote%20bag%20placed%20on%20light%20oak%20parquet%20floor%20near%20window%2C%20natural%20daylight%20creating%20soft%20highlights%2C%20minimalist%20fashion%20still%20life%2C%20warm%20neutral%20tones%2C%20clean%20uncluttered%20composition%2C%20modern%20urban%20aesthetic&width=600&height=400&seq=cat-bag-v2&orientation=landscape',
  },
  {
    name: 'Accessories Spreadsheet',
    desc: 'Dodatki, które uzupełnią styl',
    url: 'https://kaspreadsheet.com/search-920/name/Shoes.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=Elegant%20flat%20lay%20of%20fashion%20accessories%20including%20leather%20watch%20woven%20belt%20and%20sunglasses%20on%20textured%20cream%20paper%2C%20warm%20afternoon%20sunlight%2C%20editorial%20product%20photography%2C%20minimalist%20composition%2C%20terracotta%20and%20sand%20accents%2C%20refined%20modern%20style&width=600&height=400&seq=cat-access-v2&orientation=landscape',
  },
];

export default function ProductCategories() {
  return (
    <section id="categories" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-4">
            Popularne kategorie
          </h2>
          <p className="text-foreground-600 max-w-2xl mx-auto text-sm md:text-base leading-relaxed">
            Przeglądaj nasze najpopularniejsze kategorie produktów i znajdź dokładnie to, czego szukasz.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-5 mb-16">
          {featuredCategories.map((cat, i) => (
            <a
              key={cat.name}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group relative overflow-hidden rounded-xl cursor-pointer animate-[fadeInUp_0.5s_ease-out]"
              style={{ animationDelay: `${i * 0.08}s` }}
            >
              <div className="aspect-[3/2] w-full overflow-hidden">
                <img
                  src={cat.imageUrl}
                  alt={cat.name}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/20 to-transparent"></div>
              <div className="absolute bottom-0 left-0 right-0 p-4">
                <h3 className="font-heading text-white font-semibold text-sm md:text-base mb-1">{cat.name}</h3>
                <p className="text-white/70 text-xs">{cat.desc}</p>
              </div>
            </a>
          ))}
        </div>

        <div>
          <h3 className="font-heading text-xl md:text-2xl font-bold text-foreground-950 text-center mb-8">
            Wszystkie kategorie produktów
          </h3>
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-7 gap-3">
            {categories.map((cat) => (
              <a
                key={cat.name}
                href={cat.url}
                target="_blank"
                rel="noopener nofollow"
                className="flex flex-col items-center gap-2 p-4 rounded-xl bg-white border border-background-200/70 hover:border-primary-200 hover:bg-primary-50/50 transition-all duration-200 cursor-pointer group"
              >
                <div className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-100 group-hover:bg-primary-200 transition-colors duration-200">
                  <i className={`${categoryIcons[cat.name] || 'ri-store-2-line'} text-primary-500 text-base`}></i>
                </div>
                <span className="text-xs text-foreground-700 font-medium text-center whitespace-nowrap">{cat.name}</span>
              </a>
            ))}
          </div>
        </div>

        <div className="mt-12 text-center">
          <p className="text-sm text-foreground-500 mb-4">
            Chcesz dowiedzieć się więcej o Kakobuy Spreadsheet?
          </p>
          <Link
            to="/artykul/kakobuy-spreadsheet-polska-kompletny-przewodnik"
            className="inline-flex items-center gap-2 text-primary-500 hover:text-primary-600 font-semibold text-sm transition-colors duration-200"
          >
            Przeczytaj nasz kompletny przewodnik
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line"></i>
            </div>
          </Link>
        </div>
      </div>
    </section>
  );
}